import { render, staticRenderFns } from "./NeedsReviewTab.vue?vue&type=template&id=c8d5a320&scoped=true"
import script from "./NeedsReviewTab.vue?vue&type=script&lang=js"
export * from "./NeedsReviewTab.vue?vue&type=script&lang=js"
import style0 from "./NeedsReviewTab.vue?vue&type=style&index=0&id=c8d5a320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d5a320",
  null
  
)

export default component.exports